import React from "react";
import { Box } from "@mui/material";

/**
 * SidebarLayout
 * Shared sidebar container for right sidebar tabs.
 * Applies consistent background, border, radius, shadow, and spacing per Figma Frame 1000004451.
 * Children are rendered inside the padded content area.
 */
const SidebarLayout = ({ children }) => (
  <Box
    sx={{
      background: "#fff",
      // borderRadius: 2,
      boxShadow: "0 1px 2px rgba(16,30,54,0.04)",
      border: "1px solid #E5E7EB",
      height: "100%",  // Changed from minHeight to height for proper constraint
      fontFamily: "Inter, Arial, sans-serif",
      display: "flex",
      flexDirection: "column",
    }}
  >
    <Box sx={{
      p: 0,
      flex: 1,
      display: "flex",
      flexDirection: "column",
      minHeight: 0,  // Important for flex children to be scrollable
      overflow: "hidden"  // Prevent overflow from this container
    }}>
      {children}
    </Box>
  </Box>
);

export default SidebarLayout;